import Vue from "vue";
import Vuex from "vuex";

import { firestore, createUser } from "@/firebase";
import authModule from "./modules/auth.store";
import user from "./modules/user.store";
import templates from "./modules/templates.store";
import listeners from "./modules/listeners.store";
import { splitPath } from "./helpers";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    createUser,
    user_loading: true,
    drawing_opts: {
      radius: 150,
      inner_radius: 122,
      category_angle: (2 * Math.PI) / 4,
      item_angle: (2 * Math.PI) / 12
    }
  },
  getters: {
    drawing_opts: state => state.drawing_opts,
    loading: state => state.user_loading,
  },
  mutations: {
    set_drawing_opts(state, payload) {
      Object.assign(state.drawing_opts, payload);
    },
    set_loading(state, loading) {
      state.user_loading = loading;
    },
  },
  actions: {
    /**
     * Gets some data. It could be a stored data, cached data, or one that needs
     * to be fetched from the database.
     * @param {*} path 
     */
    async get({ dispatch, getters }, path) {
      const parts = splitPath(path);
      if (parts.length > 1) {
        switch(parts[0]) {
          case "templates":
            return await dispatch("templates/get", parts.slice(1));
          case "users":
            break;
          case "user":
            return await dispatch("user/get", parts.slice(1));
          case "groups":
            if (getters["user/in_group"](parts[1])) {
              return await dispatch("user/get_group")
            }
            break;
          default:
            if (parts.length % 2 == 0)
              return await firestore.doc("/" + parts.join("/")).get().data();
            else
              return await firestore.collection("/" + parts.join("/")).get().data();
        }
      } else {
        throw new Error("Path too small. Unable to fetch.");
      }
    }
  },
  modules: {
    auth: authModule,
    user,
    templates,
    listeners
  }
});
